export const chunkLoadErrorPattern =
  /ChunkLoadError|(?:Failed to fetch|error loading) dynamically imported module|Loading chunk|Importing a module script failed|Unable to preload CSS/i;

export const isChunkLoadError = (error: unknown) => {
  const message = error instanceof Error ? error.message : '';
  return (
    error instanceof Error &&
    (chunkLoadErrorPattern.test(error.name) ||
      chunkLoadErrorPattern.test(message))
  );
};

const getVitePreloadError = (event: Event) =>
  'payload' in event ? (event as Event & { payload?: unknown }).payload : null;

export const subscribeToChunkLoadErrors = (onChunkLoadError: () => void) => {
  const onUnhandledRejection = (event: PromiseRejectionEvent) => {
    if (isChunkLoadError(event.reason)) {
      onChunkLoadError();
    }
  };

  const onWindowError = (event: ErrorEvent) => {
    const fallbackError =
      typeof event.message === 'string' ? new Error(event.message) : null;
    if (isChunkLoadError(event.error ?? fallbackError)) {
      onChunkLoadError();
    }
  };

  const onVitePreloadError = (event: Event) => {
    if (isChunkLoadError(getVitePreloadError(event))) {
      onChunkLoadError();
    }
  };

  window.addEventListener('unhandledrejection', onUnhandledRejection);
  window.addEventListener('error', onWindowError);
  window.addEventListener('vite:preloadError', onVitePreloadError);

  return () => {
    window.removeEventListener('unhandledrejection', onUnhandledRejection);
    window.removeEventListener('error', onWindowError);
    window.removeEventListener('vite:preloadError', onVitePreloadError);
  };
};
